
















import { defineComponent } from '@vue/composition-api';
import { Field, Group } from '@/store/types';

export default defineComponent({
	props: {
		field: {
			required: true,
			type: Object as () => Field,
		},
		group: {
			required: false,
			type: Object as () => Group | undefined,
		},
	},
	setup() {
		return {};
	},
});
